import { render } from "./WinnersAwardsCards.vue?vue&type=template&id=630a2616&scoped=true"
import script from "./WinnersAwardsCards.vue?vue&type=script&lang=js"
export * from "./WinnersAwardsCards.vue?vue&type=script&lang=js"

import "./WinnersAwardsCards.vue?vue&type=style&index=0&id=630a2616&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630a2616"]])

export default __exports__